"use strict";
(self["webpackChunk_elephant_healthcare_primary_care_web"] = self["webpackChunk_elephant_healthcare_primary_care_web"] || []).push([[1752],{

/***/ 86492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useFetchInvoice)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/hooks/useCurrencyFormatter.ts
var useCurrencyFormatter = __webpack_require__(69775);
// EXTERNAL MODULE: ./src/client/common/featureFlags/index.ts
var featureFlags = __webpack_require__(72766);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/__generated__/useFetchInvoice.gql.ts


const defaultOptions = {};
const InvoiceDocument = lib/* gql */.Ps`
    query invoice($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    invoiceStatus
    patientType
    created
    patient {
      insurance {
        insuranceType
        insuranceDetails
      }
    }
    balance {
      total
      paid
      due
      currency
    }
    lineItems {
      id
      quantity
      cost
      automated
      disabled
      incurredAt
      priceListItem {
        uuid
        name
        priceListItemType
        cost
        payers {
          tariffId
          name
          amountInPence
          revenueDepartment
        }
        activeTariffId
        revenueDepartment
      }
      externalReference {
        origin
        foreignId
      }
    }
    payers {
      type
      name
      balance {
        total
        paid
        due
        currency
        waived
        exempt
      }
      insuranceDetails {
        name
        insuranceNumber
        nationalIdNumber
        dependent
      }
    }
  }
}
    `;
function useInvoiceQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InvoiceDocument, options);
}
function useInvoiceLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvoiceDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchInvoice.tsx







lib/* gql */.Ps`
  query invoice($invoiceId: String!) {
    invoice(invoiceId: $invoiceId) {
      _id
      invoiceStatus
      patientType
      created
      patient {
        insurance {
          insuranceType
          insuranceDetails
        }
      }
      balance {
        total
        paid
        due
        currency
      }
      lineItems {
        id
        quantity
        cost
        automated
        disabled
        incurredAt
        priceListItem {
          uuid
          name
          priceListItemType
          cost
          payers {
            tariffId
            name
            amountInPence
            revenueDepartment
          }
          activeTariffId
          revenueDepartment
        }
        externalReference {
          origin
          foreignId
        }
      }
      payers {
        type
        name
        balance {
          total
          paid
          due
          currency
          waived
          exempt
        }
        insuranceDetails {
          name
          insuranceNumber
          nationalIdNumber
          dependent
        }
      }
    }
  }
`;
const getActiveTariffCost = (activeTariffId, payers) => {
  return payers.find((p) => p.tariffId === activeTariffId).amountInPence;
};
function useFetchInvoice(invoiceId) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { currencyFormatter } = (0,useCurrencyFormatter/* default */.Z)();
  const priceListV2Enabled = (0,featureFlags/* useFeatureFlag */.ye)(
    featureFlags/* featureFlags.billing.usePriceListV2 */.VH.billing.usePriceListV2
  );
  const { loading, error, data } = useInvoiceQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      invoiceId
    },
    onError() {
      dist_default().error(
        formatMessage({
          id: "invoicing.getInvoice.error.msg",
          defaultMessage: "Failed to fetch this invoice"
        })
      );
    }
  });
  const invoice = (0,react.useMemo)(() => {
    if (loading || error) {
      return null;
    }
    const {
      invoice: {
        balance,
        lineItems,
        invoiceStatus,
        patientType,
        payers,
        patient,
        created: invoiceCreated
      }
    } = data;
    const transformedLineItems = lineItems.map((lineItem) => {
      return {
        id: lineItem.id,
        formattedPrice: priceListV2Enabled ? currencyFormatter(
          getActiveTariffCost(
            lineItem.priceListItem.activeTariffId,
            lineItem.priceListItem.payers
          )
        ) : currencyFormatter(lineItem.cost),
        cost: lineItem.cost,
        quantity: lineItem.quantity,
        priceListItem: {
          ...lineItem.priceListItem,
          externalReference: lineItem.externalReference
        },
        automated: lineItem.automated,
        disabled: lineItem.disabled,
        incurredAt: lineItem.incurredAt ? new Date(lineItem.incurredAt) : new Date(invoiceCreated)
      };
    });
    const transformedInvoice = {
      invoiceStatus,
      patientType,
      currencyCode: balance == null ? void 0 : balance.currency,
      lineItems: transformedLineItems,
      total: balance.total,
      paymentIsDue: balance.due !== 0,
      payers,
      patient,
      hasPatientPayer: !!payers.find(
        (p) => p.type === "PATIENT" && p.balance.paid > 0
      )
    };
    return transformedInvoice;
  }, [loading, error, data]);
  return { loading, error, invoice };
}


/***/ }),

/***/ 18921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useFetchPatientDetails)
});

// UNUSED EXPORTS: QUERY

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/__generated__/useFetchPatientDetails.gql.ts


const defaultOptions = {};
const InvoicePatientDetailsDocument = lib/* gql */.Ps`
    query invoicePatientDetails($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    patientType
    inpatientDetails {
      ward
      inpatientNumber
      admission
      discharge
      dailyRebateAmount
    }
  }
}
    `;
function useInvoicePatientDetailsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InvoicePatientDetailsDocument, options);
}
function useInvoicePatientDetailsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvoicePatientDetailsDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchPatientDetails.tsx




const QUERY = lib/* gql */.Ps`
  query invoicePatientDetails($invoiceId: String!) {
    invoice(invoiceId: $invoiceId) {
      _id
      patientType
      inpatientDetails {
        ward
        inpatientNumber
        admission
        discharge
        dailyRebateAmount
      }
    }
  }
`;
function useFetchPatientDetails(invoiceId) {
  var _a, _b;
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const { loading, error, data } = useInvoicePatientDetailsQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      invoiceId
    },
    onError() {
      dist_default().error(
        formatMessage({
          id: "invoicing.getPatientDetails.error.msg",
          defaultMessage: "Failed to fetch the patient details"
        }),
        {}
      );
    }
  });
  return {
    loading,
    error,
    patientType: (_a = data == null ? void 0 : data.invoice) == null ? void 0 : _a.patientType,
    inpatientDetails: (_b = data == null ? void 0 : data.invoice) == null ? void 0 : _b.inpatientDetails
  };
}


/***/ }),

/***/ 47921:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useFetchPrintableInvoice)
});

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(41552);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/__generated__/useFetchPrintableInvoice.gql.ts


const defaultOptions = {};
const InvoiceForReceiptDocument = lib/* gql */.Ps`
    query invoiceForReceipt($invoiceId: String!) {
  invoice(invoiceId: $invoiceId) {
    _id
    invoiceNumber
    patientType
    patient {
      cardId
      passport {
        uid
      }
      person {
        name {
          firstname
          middlename
          lastname
        }
        dob
      }
      insurance {
        insuranceType
        insuranceDetails
      }
    }
    created
    createdBy {
      person {
        firstname
        lastname
      }
      uuid
    }
    facility {
      name
      addresses {
        ward
        street
        subCounty
        state
      }
    }
    inpatientDetails {
      inpatientNumber
      admission
      discharge
      ward
      dailyRebateAmount
    }
    invoiceStatus
    balance {
      paid
      total
      due
      currency
    }
    lineItems {
      id
      priceListItem {
        name
        priceListItemType
      }
      quantity
      cost
      disabled
    }
    payers {
      type
      name
      balance {
        paid
        total
      }
      insuranceDetails {
        name
        insuranceNumber
        dependent
      }
    }
    transactions {
      payer {
        type
      }
      payment {
        paymentMethod
        authCode
      }
      refund {
        paymentMethod
        authCode
      }
      amount {
        value
      }
      actionedBy {
        person {
          firstname
          lastname
        }
      }
    }
  }
}
    `;
function useInvoiceForReceiptQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useQuery/* useQuery */.a(InvoiceForReceiptDocument, options);
}
function useInvoiceForReceiptLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(InvoiceForReceiptDocument, options);
}

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useFetchPrintableInvoice.tsx


lib/* gql */.Ps`
  query invoiceForReceipt($invoiceId: String!) {
    invoice(invoiceId: $invoiceId) {
      _id
      invoiceNumber
      patientType
      patient {
        cardId
        passport {
          uid
        }
        person {
          name {
            firstname
            middlename
            lastname
          }
          dob
        }
        insurance {
          insuranceType
          insuranceDetails
        }
      }
      created
      createdBy {
        person {
          firstname
          lastname
        }
        uuid
      }
      facility {
        name
        addresses {
          ward
          street
          subCounty
          state
        }
      }
      inpatientDetails {
        inpatientNumber
        admission
        discharge
        ward
        dailyRebateAmount
      }
      invoiceStatus
      balance {
        paid
        total
        due
        currency
      }
      lineItems {
        id
        priceListItem {
          name
          priceListItemType
        }
        quantity
        cost
        disabled
      }
      payers {
        type
        name
        balance {
          paid
          total
        }
        insuranceDetails {
          name
          insuranceNumber
          dependent
        }
      }
      transactions {
        payer {
          type
        }
        payment {
          paymentMethod
          authCode
        }
        refund {
          paymentMethod
          authCode
        }
        amount {
          value
        }
        actionedBy {
          person {
            firstname
            lastname
          }
        }
      }
    }
  }
`;
function useFetchPrintableInvoice(invoiceId, hookOptions) {
  return useInvoiceForReceiptQuery({
    variables: { invoiceId },
    ...hookOptions
  });
}


/***/ }),

/***/ 23218:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ usePrintThermalReceipt)
/* harmony export */ });
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52018);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var elephant_web_client_billing_printV2Receipt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23935);
/* harmony import */ var elephant_web_client_components_PatientOverview_Tabs_Invoices_hooks_useCurrencyFormatter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69775);
/* harmony import */ var _printing_useThermalPrinter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67891);
/* harmony import */ var _useFetchPrintableInvoice__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47921);






function patchCurrencyFormatter(currencyFormatter) {
  return {
    format: (amountInPence) => currencyFormatter(amountInPence).replace(/₵/g, "\xA2")
  };
}
function usePrintThermalReceipt(invoiceId) {
  const intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
  const { currencyFormatter } = (0,elephant_web_client_components_PatientOverview_Tabs_Invoices_hooks_useCurrencyFormatter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
  const {
    print,
    havePrinter,
    reset: resetPrinter,
    error: printerError
  } = (0,_printing_useThermalPrinter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
  const [fetchError, setFetchError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
  const { refetch: fetchInvoice } = (0,_useFetchPrintableInvoice__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(invoiceId, {
    fetchPolicy: "network-only",
    skip: true
  });
  const resetErrors = () => {
    resetPrinter();
    setFetchError(null);
  };
  async function thermalPrintReceipt(invoice, printer) {
    await (0,elephant_web_client_billing_printV2Receipt__WEBPACK_IMPORTED_MODULE_1__/* .printV2Receipt */ .b)({
      invoice,
      printer,
      currencyFormatter: patchCurrencyFormatter(currencyFormatter),
      penceToPounds: (i) => i,
      intl
    });
  }
  const printReceipt = async () => {
    try {
      const {
        data: { invoice },
        error: err
      } = await fetchInvoice();
      if (err) {
        setFetchError(err);
      } else {
        await print((printer) => thermalPrintReceipt(invoice, printer));
      }
    } catch (e) {
      setFetchError(e);
    }
  };
  return { havePrinter, printReceipt, resetErrors, fetchError, printerError };
}


/***/ }),

/***/ 6764:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ useUpdateInsurers)
});

// UNUSED EXPORTS: useTransformPayers

// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@14.6.0/node_modules/graphql-tag/lib/index.js
var lib = __webpack_require__(24520);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-toast@0.5.1_yiohjz765rzfqr5c6wot52qpt4/node_modules/@elephant-healthcare/mui-toast/dist/index.js
var dist = __webpack_require__(28841);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.7.14_piqqaowiwdqyjgcsz6rvyqu2hy/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(28205);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/__generated__/useUpdateInsurers.gql.ts


const defaultOptions = {};
const AddPayersDocument = lib/* gql */.Ps`
    mutation addPayers($input: AddPayersInput!) {
  addPayers(input: $input) {
    _id
    payers {
      type
      name
      balance {
        total
        paid
        due
      }
      insuranceDetails {
        name
        insuranceNumber
        nationalIdNumber
        dependent
      }
    }
  }
}
    `;
function useAddPayersMutation(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation/* useMutation */.D(AddPayersDocument, options);
}

// EXTERNAL MODULE: ./src/__generated__/base.gql.ts
var base_gql = __webpack_require__(3047);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceCard/hooks/useUpdateInsurers.ts





lib/* gql */.Ps`
  mutation addPayers($input: AddPayersInput!) {
    addPayers(input: $input) {
      _id
      payers {
        type
        name
        balance {
          total
          paid
          due
        }
        insuranceDetails {
          name
          insuranceNumber
          nationalIdNumber
          dependent
        }
      }
    }
  }
`;
const useTransformPayers = (insurers) => {
  const formattedInsurers = insurers.map((i) => {
    var _a, _b, _c, _d;
    return {
      name: (i == null ? void 0 : i.name) || (i == null ? void 0 : i.type),
      type: base_gql/* PayerType.Insurer */.nk.Insurer,
      balance: {
        paid: 0,
        due: (_b = (_a = i == null ? void 0 : i.balance) == null ? void 0 : _a.total) != null ? _b : 0,
        total: (_d = (_c = i == null ? void 0 : i.balance) == null ? void 0 : _c.total) != null ? _d : 0
      },
      insuranceDetails: (i == null ? void 0 : i.insuranceDetails) && {
        name: i.insuranceDetails.schemeName || i.insuranceDetails.name || (i == null ? void 0 : i.name) || (i == null ? void 0 : i.type),
        nationalIdNumber: i.insuranceDetails.nationalIdNumber,
        insuranceNumber: i.insuranceDetails.insuranceNumber,
        dependent: i.insuranceDetails.dependent
      } || void 0
    };
  });
  return formattedInsurers;
};
function useUpdateInsurers(payers, invoiceId) {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const [updateInsurers] = useAddPayersMutation({
    variables: {
      input: {
        _id: invoiceId,
        payers: useTransformPayers(payers)
      }
    },
    onError() {
      dist_default().error(
        formatMessage({
          id: "invoicing.updateInsurers.error.msg",
          defaultMessage: "Failed to update insurers"
        })
      );
    },
    onCompleted() {
      dist_default().success(
        formatMessage({
          id: "invoicing.updateInsurers.success.msg",
          defaultMessage: "Insurers updated successfully"
        })
      );
    }
  });
  return { updateInsurers };
}


/***/ }),

/***/ 51952:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useUpdateLineItems)
/* harmony export */ });
/* unused harmony export transformLineItems */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28205);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11313);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28841);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__);




const ERROR_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
  id: "invoicing.updateLineItems.error.msg",
  defaultMessage: "Failed to update invoice line items"
});
const SUCCESS_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
  id: "invoicing.updateLineItems.success.msg",
  defaultMessage: "Line items updated successfully"
});
const SET_LINE_ITEMS = _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps`
  mutation setLineItems($input: SetLineItemsInput!) {
    setLineItems(input: $input) {
      _id
      lineItems {
        id
        quantity
        cost
        priceListItem {
          uuid
          name
          priceListItemType
          cost
        }
      }
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;
const transformLineItems = (lineItems) => {
  var _a;
  return (_a = lineItems == null ? void 0 : lineItems.filter(({ priceListItem }) => priceListItem == null ? void 0 : priceListItem.uuid)) == null ? void 0 : _a.map(({ priceListItem, id: itemId, quantity }) => ({
    id: itemId || null,
    priceListItem: {
      uuid: priceListItem.uuid
    },
    quantity: Number(quantity)
  }));
};
function useUpdateLineItems(invoiceId) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const [saving, setSaving] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [saved, setSaved] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [setLineItems] = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)(SET_LINE_ITEMS, {
    onError() {
      _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().error(formatMessage(ERROR_MESSAGE), {});
    },
    onCompleted() {
      setSaving(false);
      setSaved(true);
      _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().success(formatMessage(SUCCESS_MESSAGE), {});
    }
  });
  const updateLineItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (lineItems) => {
      setSaving(true);
      await setLineItems({
        variables: {
          input: {
            _id: invoiceId,
            lineItems: transformLineItems(lineItems)
          }
        }
      });
    },
    [setLineItems, invoiceId]
  );
  return { updateLineItems, saving, saved };
}


/***/ }),

/***/ 7915:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useUpdateLineItemsV2)
/* harmony export */ });
/* unused harmony export transformLineItems */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93236);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28205);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11313);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28841);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1__);




const ERROR_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
  id: "invoicing.updateLineItems.error.msg",
  defaultMessage: "Failed to update invoice line items"
});
const SUCCESS_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* .defineMessage */ .Em)({
  id: "invoicing.updateLineItems.success.msg",
  defaultMessage: "Line items updated successfully"
});
const SET_LINE_ITEMS = _apollo_client__WEBPACK_IMPORTED_MODULE_3__/* .gql */ .Ps`
  mutation setLineItemsV2($input: SetInvoiceLineItemsV2Input!) {
    setLineItemsV2(input: $input) {
      _id
      lineItems {
        id
        quantity
        cost
        priceListItem {
          uuid
          name
          priceListItemType
          cost
        }
        disabled
      }
      balance {
        total
        paid
        due
        currency
      }
    }
  }
`;
const transformLineItems = (lineItems) => {
  var _a;
  const items = (_a = lineItems == null ? void 0 : lineItems.filter(({ priceListItem }) => priceListItem)) == null ? void 0 : _a.map(({ priceListItem, id: itemId, quantity, disabled }) => ({
    id: itemId || null,
    priceListItem: {
      origin: priceListItem.externalReference.origin,
      foreignId: priceListItem.externalReference.foreignId,
      activeTariffId: priceListItem.activeTariffId,
      revenueDepartment: priceListItem.revenueDepartment
    },
    quantity: Number(quantity),
    disabled
  }));
  return items;
};
function useUpdateLineItemsV2(invoiceId) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const [saving, setSaving] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [saved, setSaved] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const [setLineItems] = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)(SET_LINE_ITEMS, {
    onCompleted() {
      setSaving(false);
      setSaved(true);
      _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().success(formatMessage(SUCCESS_MESSAGE), {});
    },
    onError() {
      _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_1___default().error(formatMessage(ERROR_MESSAGE), {});
    }
  });
  const updateLineItems = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    async (lineItems) => {
      setSaving(true);
      await setLineItems({
        variables: {
          input: {
            id: invoiceId,
            lineItems: transformLineItems(lineItems)
          }
        }
      });
    },
    [setLineItems, invoiceId]
  );
  return { updateLineItems, saving, saved };
}


/***/ }),

/***/ 51341:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ useUpdatePatientDetails)
/* harmony export */ });
/* unused harmony export UPDATE_PATIENT_DETAILS */
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24520);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28205);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11313);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52018);
/* harmony import */ var ramda__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99129);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28841);
/* harmony import */ var _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89856);





const UPDATE_PATIENT_DETAILS = _apollo_client__WEBPACK_IMPORTED_MODULE_2__/* .gql */ .Ps`
  mutation setPatientType($input: SetPatientTypeInput!) {
    setPatientType(input: $input) {
      _id
      patientType
      inpatientDetails {
        ward
        inpatientNumber
        admission
        discharge
        dailyRebateAmount
      }
    }
  }
`;
const ERROR_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* .defineMessage */ .Em)({
  id: "invoicing.updatePatientInfo.error.msg",
  defaultMessage: "Failed to update the patient information"
});
const SUCCESS_MESSAGE = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* .defineMessage */ .Em)({
  id: "invoicing.updatePatientInfo.success.msg",
  defaultMessage: "Patient details updated successfully"
});
function useUpdatePatientDetails(patient, inpatientDetails, invoiceId) {
  const { formatMessage } = (0,react_intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
  const [updatePatientDetails, { loading }] = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_5__/* .useMutation */ .D)(
    UPDATE_PATIENT_DETAILS,
    {
      variables: {
        input: {
          _id: invoiceId,
          patientType: patient,
          inpatientDetails: patient === _types__WEBPACK_IMPORTED_MODULE_1__/* .PatientType.INPATIENT */ .l.INPATIENT ? (0,ramda__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(["__typename", "dailyRebateAmount"], inpatientDetails) : null
        }
      },
      onError() {
        _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_0___default().error(formatMessage(ERROR_MESSAGE), {});
      },
      onCompleted() {
        _elephant_healthcare_mui_toast__WEBPACK_IMPORTED_MODULE_0___default().success(formatMessage(SUCCESS_MESSAGE), {});
      }
    }
  );
  return { updatePatientDetails, loading };
}


/***/ }),

/***/ 26601:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PZ": () => (/* reexport safe */ _InvoiceCard__WEBPACK_IMPORTED_MODULE_0__.P)
/* harmony export */ });
/* harmony import */ var _InvoiceCard__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79784);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89856);
/* harmony import */ var _InvoiceActions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90848);





/***/ }),

/***/ 89856:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": () => (/* binding */ PriceListItemType),
/* harmony export */   "l": () => (/* binding */ PatientType)
/* harmony export */ });
var PriceListItemType = /* @__PURE__ */ ((PriceListItemType2) => {
  PriceListItemType2["PROCEDURE"] = "Procedure";
  PriceListItemType2["CONSULTATION"] = "Consultation";
  PriceListItemType2["PRESCRIPTION"] = "Prescription";
  PriceListItemType2["INVESTIGATION"] = "Investigation";
  PriceListItemType2["INVENTORY"] = "Inventory";
  PriceListItemType2["OTHER"] = "Other";
  return PriceListItemType2;
})(PriceListItemType || {});
var PatientType = /* @__PURE__ */ ((PatientType2) => {
  PatientType2["INPATIENT"] = "Inpatient";
  PatientType2["OUTPATIENT"] = "Outpatient";
  return PatientType2;
})(PatientType || {});


/***/ }),

/***/ 38617:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A$": () => (/* reexport */ InvoiceFilters),
  "UY": () => (/* reexport */ types/* InvoiceStatus */.U)
});

// UNUSED EXPORTS: InvoiceFilterStatus

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.1.0/node_modules/react/index.js
var react = __webpack_require__(93236);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/styles/styled.js
var styled = __webpack_require__(69525);
// EXTERNAL MODULE: ./node_modules/.pnpm/@material-ui+core@4.12.4_633m7c4we3uekpyriichjdp5zu/node_modules/@material-ui/core/esm/Card/Card.js
var Card = __webpack_require__(90010);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@6.4.7_cn5jcockkrembw54osxy7yvfpi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(52018);
// EXTERNAL MODULE: ./node_modules/.pnpm/@elephant-healthcare+mui-input@0.3.5_atek3e5pugfjeukz7kzynbm6iy/node_modules/@elephant-healthcare/mui-input/dist/module.js
var dist_module = __webpack_require__(34948);
// EXTERNAL MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/types.ts
var types = __webpack_require__(49361);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/InvoiceStatusFilter.tsx




const InvoiceStatusFilter = ({
  setInvoiceStatus,
  invoiceStatus
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const selectLabel = formatMessage({
    id: "invoices.filter.type.label",
    defaultMessage: "Invoice Type"
  });
  const invoiceStatusOptions = react.useMemo(
    () => [
      {
        value: "ALL",
        label: formatMessage({
          id: "invoices.filter.all.label",
          defaultMessage: "All"
        })
      },
      {
        value: types/* InvoiceFilterStatus.PAID */.$.PAID,
        label: formatMessage({
          id: "invoices.filter.paid.label",
          defaultMessage: "Paid"
        })
      },
      {
        value: types/* InvoiceFilterStatus.UNPAID */.$.UNPAID,
        label: formatMessage({
          id: "invoices.filter.unpaid.label",
          defaultMessage: "Unpaid"
        })
      },
      {
        value: types/* InvoiceFilterStatus.REFUNDED */.$.REFUNDED,
        label: formatMessage({
          id: "invoices.filter.refunded.label",
          defaultMessage: "Refunded"
        })
      },
      {
        value: types/* InvoiceFilterStatus.VOID */.$.VOID,
        label: formatMessage({
          id: "invoices.filter.void.label",
          defaultMessage: "Void"
        })
      }
    ],
    [formatMessage]
  );
  return /* @__PURE__ */ react.createElement(dist_module/* SelectField */.mg, {
    label: selectLabel,
    options: invoiceStatusOptions,
    fullWidth: true,
    hideHelper: true,
    name: "invoiceStatusFilter",
    id: "invoice-status-filter-select",
    selectProps: {
      role: "spinbutton",
      value: invoiceStatus,
      onChange: (e) => setInvoiceStatus(e.target.value)
    }
  });
};
/* harmony default export */ const InvoiceFilters_InvoiceStatusFilter = (InvoiceStatusFilter);

// EXTERNAL MODULE: ./node_modules/.pnpm/dayjs@1.8.36/node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(4548);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/.pnpm/use-debounce@8.0.4_react@18.1.0/node_modules/use-debounce/dist/index.module.js
var index_module = __webpack_require__(53890);
;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/InvoiceFilters.tsx







const Container = (0,styled/* default */.Z)(Card/* default */.Z)(({ theme }) => ({
  display: "flex",
  padding: theme.spacing(1),
  flexDirection: "row",
  flexWrap: "wrap",
  gap: theme.spacing(1),
  "& > *": {
    flex: 1,
    minWidth: "200px"
  }
}));
const InvoiceFilters = ({
  fromDate,
  toDate,
  invoiceStatus,
  setFromDate,
  setToDate,
  setInvoiceStatus
}) => {
  const { formatMessage } = (0,useIntl/* default */.Z)();
  const setFromDebounced = (0,index_module/* useDebouncedCallback */.y1)(
    (date) => setFromDate(dayjs_min_default()(date).format("YYYY-MM-DD")),
    800
  );
  const setToDebounced = (0,index_module/* useDebouncedCallback */.y1)(
    (date) => setToDate(dayjs_min_default()(date).format("YYYY-MM-DD")),
    800
  );
  return /* @__PURE__ */ react.createElement(Container, null, /* @__PURE__ */ react.createElement(InvoiceFilters_InvoiceStatusFilter, {
    setInvoiceStatus,
    invoiceStatus
  }), /* @__PURE__ */ react.createElement(dist_module/* DatePicker */.Mt, {
    hideHelper: true,
    label: formatMessage({
      id: "invoices.filter.from",
      defaultMessage: "From"
    }),
    inputProps: { "aria-label": "Change From Date" },
    onChange: setFromDebounced,
    value: fromDate != null ? fromDate : null
  }), /* @__PURE__ */ react.createElement(dist_module/* DatePicker */.Mt, {
    hideHelper: true,
    label: formatMessage({
      id: "invoices.filter.to",
      defaultMessage: "To"
    }),
    inputProps: { "aria-label": "Change To Date" },
    onChange: setToDebounced,
    value: toDate != null ? toDate : null
  }));
};

;// CONCATENATED MODULE: ./src/client/components/PatientOverview/Tabs/Invoices/components/InvoiceFilters/index.ts




/***/ }),

/***/ 49361:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": () => (/* binding */ InvoiceFilterStatus),
/* harmony export */   "U": () => (/* binding */ InvoiceStatus)
/* harmony export */ });
var InvoiceFilterStatus = /* @__PURE__ */ ((InvoiceFilterStatus2) => {
  InvoiceFilterStatus2["ALL"] = "ALL";
  InvoiceFilterStatus2["PAID"] = "PAID";
  InvoiceFilterStatus2["UNPAID"] = "UNPAID";
  InvoiceFilterStatus2["REFUNDED"] = "REFUNDED";
  InvoiceFilterStatus2["VOID"] = "VOID";
  return InvoiceFilterStatus2;
})(InvoiceFilterStatus || {});
var InvoiceStatus = /* @__PURE__ */ ((InvoiceStatus2) => {
  InvoiceStatus2["Draft"] = "DRAFT";
  InvoiceStatus2["Paid"] = "PAID";
  InvoiceStatus2["PartiallyPaid"] = "PARTIALLY_PAID";
  InvoiceStatus2["PartiallyRefunded"] = "PARTIALLY_REFUNDED";
  InvoiceStatus2["Refunded"] = "REFUNDED";
  InvoiceStatus2["Unpaid"] = "UNPAID";
  InvoiceStatus2["Void"] = "VOID";
  return InvoiceStatus2;
})(InvoiceStatus || {});


/***/ })

}]);